import React from "react"
import { HashLink as Link } from 'react-router-hash-link';

//const postUrlProperties     = API_URL + "properties";

class Header extends React.Component{
  constructor(props){
    super(props);
    this.state = {};
  }

  handleLogout(event) {
    event.preventDefault();
    localStorage.removeItem("api_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    this.props.setSession(false)
  }

  render(){
    return(
      <header id="main-header">
        <nav>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <Link to="/"><span className="logo-header"> </span></Link>
              </div>
              <div className="col-md-3"></div>
              <div className="col-md-3"></div>
              <div className="col-md-3 segment-filter ">
                <span className="invert-title segment-reserva"></span>
                <div className="row">
                  <div className="col-md-2">
                    <div className="segment-list">
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="profile-options">
                      <div className="icon-component">
                        <span className="icon-notify"></span>
                      </div>
                      <div className="icon-component">
                        <span className="icon-news"></span>
                      </div>
                      <div className="icon-component">
                        <Link to="/setup"><span className="icon-settings"></span></Link>
                      </div>
                      <div className="icon-component" onClick={this.handleLogout.bind(this)}>
                        <span className="icon-logout"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    )}
  };

export default Header


// WEBPACK FOOTER //
// ./src/Setup/components/Header.js